<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :showAdd="false"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: `reminders/${activeName}/`,
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="reminder in types"
        :key="reminder.name"
        :label="$t(reminder.label)"
        :name="reminder.name"
      >
        <ReminderTable
          :tableData="tableData"
          :alpha="alphaList"
          :type="activeName"
          :loading="loading"
        />
      </el-tab-pane>
    </el-tabs>
  </Content>
</template>

<script>
import {
  driverReminder,
  servicesReminder,
  vehiclesReminder,
} from '@/api/reminders'
import ReminderTable from './reminder/table.vue'
import { licenseChars } from '@/api/global'

export default {
  data() {
    return {
      tableData: {
        results: [],
      },
      alphaList: [
        {
          char: '',
          code: '',
        },
      ],

      types: [
        { name: 'drivers', label: 'DRIVERS' },
        { name: 'company-vehicle-services', label: 'VEHICLE_SERVICE' },
        { name: 'comapny-vehicles', label: 'VEHICLES' },
      ],
      loading: true,
      activeName: this.$route.query.active || 'drivers',
      pagination: {
        count: 0,
        current: +this.$route.query.p || 1,
        request: '',
      },
    }
  },

  methods: {
    handleClick() {
      this.updateRoute(this.activeName)
    },

    fetchData(type, page = 1) {
      this.loading = true
      let apiName

      switch (type) {
        case 'drivers':
          apiName = driverReminder
          break
        case 'company-vehicle-services':
          apiName = servicesReminder
          break
        case 'comapny-vehicles':
          apiName = vehiclesReminder
          break
      }

      apiName
        .api({ params: { p: page } })
        .then((res) => {
          if (res) {
            this.tableData = res
            this.pagination.count = res.count
            this.pagination.current = page
            this.pagination.request = `reminders/${type}/`
          }
        })
        .catch((error) => {
          console.error('Failed to fetch data:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },

    updateRoute(active) {
      this.$router.push({ query: { ...this.$route.query, active, p: 1 } })
    },
  },

  watch: {
    '$route.query.active'(newActive) {
      this.activeName = newActive || 'drivers'
      this.fetchData(this.activeName, this.pagination.current)
    },
  },

  mounted() {
    this.fetchData(this.activeName, this.pagination.current)
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },

  components: {
    ReminderTable,
  },
}
</script>
